export const center_app_version = {"commit_sha": "fac5b061"}
